import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";
import Items from "../Items.js";
import Avatars from "../Avatars.js";

export default class AvatarController {

  constructor(app) {
    this.app = app;
    this.avatarsHelper = new Avatars();
    this.itemsHelper = app.items;

  }

  show(path, model) {
    model = this.getModel();

    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const userdata = app.userdata;
 
   

    let coins = userdata.coins;

    //get avatars
    var avatars = [];


    //add gravatar avatars
    var gravatarUrl = this.avatarsHelper.get_gravatar(userdata.email);
    avatars.push({ icon: gravatarUrl,url:gravatarUrl, owned: true });

    if(userdata.avatar_discord){
      avatars.push({ icon: userdata.avatar_discord,url:userdata.avatar_discord, owned: true });
    }

    //get list of avatars
    var items = this.itemsHelper.allItems;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.type === "Avatar") {
        avatars.push({ icon: item.icon,url:item.url, owned: true });
      }
    }


    const model = {
      items: avatars,
      coins: coins
    }

    return model;

  }
  selectAvatar(url) {
    //todo: on set avatar, upload to image server and get new url and save in userdata.  Could use this for all platforms
    const userdata = this.app.userdata;
    userdata.avatar = url;
    window.location = "#/Profile";
  }
}